import { path } from 'tg-commons'
import { customRef, getCurrentInstance, toRaw, watch } from 'vue'

/** 获取当前组件的名字 */
export function useComponentName(): string | undefined {
  const type = getCurrentInstance()?.type
  let name = type?.name ?? type?.__name
  if (!name) {
    const file = type?.__file
    if (file) {
      name = path.basename(file, '.vue')
    }
  }
  return name
}

/**
 * 将v-model转换成Ref变量, 并防止递归调用
 */
export function useLocalModel<P extends object, K extends keyof P & string, Name extends string>(
  props: P,
  key: K,
  emit: (name: Name, ...args: any[]) => void,
) {
  return customRef<P[K]>((track, trigger) => {
    let local = props[key]
    watch(() => props[key], (v) => {
      if (local === toRaw(v)) {
        // 防止emit出去的值, 被设置回来
        return
      }
      local = v
      trigger()
    })

    return {
      get: () => {
        track()
        return local
      },
      set: (v) => {
        local = v
        emit(`update:${key}` as Name, v)
      },
    }
  })
}
